import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileDownload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFileDownload"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H12V10H20V22H4V2ZM12 20.4142L8.08579 16.5L9.5 15.0858L11 16.5858V12H13V16.5858L14.5 15.0858L15.9142 16.5L12 20.4142Z" fill="currentColor"/><Path d="M14 2.58579L19.4142 8H14V2.58579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileDownload;
